// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1e8o1b66 div[role=tablist]{gap:var(--ds-space-050,4px)}._1d96n7od div[role=tablist] [role=tab][aria-selected=true]:after{inset-inline-start:unset}\n._1rxjn7od div[role=tablist]:before{inset-inline-start:unset}\n._k88nn7od div[role=tablist]{margin-inline-start:unset}\n._n3tdv47k{padding-bottom:var(--ds-space-250,20px)}\n._v229n7od div[role=tablist] [role=tab]:hover:after{inset-inline-start:unset}", ""]);
// Exports
module.exports = exports;
